/**
 * Cores padronizadas para o Wizard de Relatórios
 */
export const RELATORIO_CORES = {
  // Cores principais
  PRIMARIA: '#006533',      // Verde escuro
  SECUNDARIA: '#d6ac41',    // Dourado/Amarelo
  TERCIARIA: '#fefefe',     // Quase branco
  
  // Cores de status (manter para calendário)
  SUCESSO: '#28a745',       // Verde (apenas para calendário)
  PERIGO: '#dc3545',        // Vermelho (apenas para botões de excluir)
  AVISO: '#ffc107',         // Amarelo (apenas para calendário)
  INFO: '#17a2b8',          // Azul (apenas para calendário)
  
  // Cores neutras
  CINZA_CLARO: '#f8f9fa',
  CINZA_MEDIO: '#adb5bd',
  CINZA_ESCURO: '#6c757d',
  BRANCO: '#ffffff',

  // Estilo minimalista (alinhado à home / Corregedoria)
  BORDA_CARD: '#e9ecef',
  SOMBRA_CARD: '0 1px 3px rgba(0,0,0,0.05)',
} as const;

/**
 * Cores dos status de comparecimento (legenda e calendário devem usar as mesmas).
 */
export const COMPARECIMENTO_CORES = {
  PRESENTE: '#198754',
  AUSENTE: '#ffc107',
  REMOTO: '#0d6efd',
  IMPEDIMENTO: '#6c757d',
  NAO_MARCADO: '#e9ecef',
  DIA_SEM_OBRIGACAO_FUNDO: '#fff3cd',
  DIA_SEM_OBRIGACAO_TEXTO: '#856404',
} as const;
